import React from 'react';
import ReactTooltip from 'react-tooltip';
import styleVariables from '../../../styles/variables.module.scss';
import styles from './Tooltip.module.scss';

interface TooltipProps {
  content: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, content }) => (
  <>
    <span data-tip={content} className={styles.elementWrapper}>
      {children}
    </span>
    <ReactTooltip
      backgroundColor={styleVariables.colorPopup}
      effect="solid"
      className={styles.tooltip}
      place="bottom"
    />
  </>
);

export default Tooltip;
